import React from 'react';
import {
  Button,
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';
import ClientsList from '../components/ClientsList';
import Legend from '../components/Legend';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Line, Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartDataAnnotations from 'chartjs-plugin-annotation';
import ChartDetails from '../components/ChartDetails';
import axios from 'axios';

class CoefficientiEIndici extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showChart: false,
      // chartDetails states
      showChartDetails: false,
      chartDetailsTitle: '',
      chartDetailsDescription: '',
      chartDetailsChartData: null,
      chartDetailsChartOptions: null,
      bestClients: [],
      clientsData: [],
      clientsForLegend: [],
      chartCCBData: {
        datasets: [],
        labels: [],
      },
      chartCCBOptions: {
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              min: -30,
              max: 45,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartCCMData: {
        datasets: [],
        labels: [],
      },
      chartCCMOptions: {
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              min: 100,
              max: 160,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartCPFData: {
        datasets: [],
        labels: [],
      },
      chartCPFOptions: {
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              min: -20,
              max: 20,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartRatingData: {
        datasets: [],
        labels: [],
      },
      chartRatingOptions: {
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: '23',
              borderColor: "rgba(170,170,170,0.5)",
              borderDash: [20, 15],
              label: {
                backgroundColor: 'rgba(0,0,0,0)',
                fontColor: "rgba(0,228,186,0.6)",
                fontStyle: "bold",
                content: "Rischio Elevato",
                enabled: true,
                position: "right"
              }
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: '31',
              borderColor: "rgba(170,170,170,0.5)",
              borderDash: [20, 15],
              label: {
                backgroundColor: 'rgba(0,0,0,0)',
                fontColor: "rgba(0,228,186,0.6)",
                fontStyle: "bold",
                content: "Rischio Alto",
                enabled: true,
                position: "right"
              }
            }, {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: '39',
              borderColor: "rgba(170,170,170,0.5)",
              borderDash: [20, 15],
              label: {
                backgroundColor: 'rgba(0,0,0,0)',
                fontColor: "rgba(0,228,186,0.6)",
                fontStyle: "bold",
                content: "Rischio Medio",
                enabled: true,
                position: "right"
              }
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: '47',
              borderColor: "rgba(170,170,170,0.5)",
              borderDash: [20, 15],
              label: {
                backgroundColor: 'rgba(0,0,0,0)',
                fontColor: "rgba(0,228,186,0.6)",
                fontStyle: "bold",
                content: "Rischio Basso",
                enabled: true,
                position: "right"
              }
            }, {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: '60',
              borderColor: "rgba(170,170,170,0.5)",
              borderDash: [20, 15],
              label: {
                backgroundColor: 'rgba(0,0,0,0)',
                fontColor: "rgba(0,228,186,0.6)",
                fontStyle: "bold",
                content: "Rischio Nullo",
                enabled: true,
                position: "right"
              }
            }
          ]
        },
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              min: 0,
              max: 65,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartBoostData: {
        datasets: [],
        labels: [],
      },
      chartBoostOptions: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 5,
                min: 0,
                max: 100,
                beginAtZero: true,
                fontColor: "#fff"
              },
              stacked: true,
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontColor: "#fff"
              }
            },
          ],
        },
      }
    }
    this.toggleChart = this.toggleChart.bind(this)
    this.toggleChartDetails = this.toggleChartDetails.bind(this)
    this.api = '/api/v1';
  }

  componentDidMount() {
    //vertical annotations
    Chart.plugins.register(ChartDataAnnotations);
    Chart.plugins.unregister(ChartDataLabels);

    let calls = []

    //get best ccb
    let data = new FormData()
    data.append('filters', JSON.stringify({
      max_result: 1,
      from: this.props.user.reports.newestReportYear - 4,
      to: this.props.user.reports.newestReportYear,
      indexName: 'ccb',
      clientsId: []
    }))
    calls.push(axios.post(`${this.api}/clients-with-filters`, data))

    //get best ccm
    data = new FormData()
    data.append('filters', JSON.stringify({
      max_result: 1,
      from: this.props.user.reports.newestReportYear - 4,
      to: this.props.user.reports.newestReportYear,
      indexName: 'ccm',
      clientsId: []
    }))
    calls.push(axios.post(`${this.api}/clients-with-filters`, data))

    //get best cpf
    data = new FormData()
    data.append('filters', JSON.stringify({
      max_result: 1,
      from: this.props.user.reports.newestReportYear - 4,
      to: this.props.user.reports.newestReportYear,
      indexName: 'cpf',
      clientsId: []
    }))
    calls.push(axios.post(`${this.api}/clients-with-filters`, data))

    //get best rating
    data = new FormData()
    data.append('filters', JSON.stringify({
      max_result: 1,
      from: this.props.user.reports.newestReportYear - 4,
      to: this.props.user.reports.newestReportYear,
      indexName: 'punteggio_my_client',
      clientsId: []
    }))
    calls.push(axios.post(`${this.api}/clients-with-filters`, data))

    axios.all(calls)
      .then(responseArr => {
        let { bestClients } = this.state
        responseArr.map(res => {
          bestClients.push(res.data.data)
        })
        this.setState({
          bestClients: bestClients
        })
      }).catch((e) => {
        // alert('Si è verificato un errore.')
        console.log(e)
        this.setState({
          error: 'Si è verificato un errore',
          buttonClasses: "animation-on-hover float-right disabled",
          loading: false
        });
      });
  }

  loadChartsData() {
    let datasetsChartCCB = [], labelsChartCCB = [];
    let datasetsChartCCM = [], labelsChartCCM = [];
    let datasetsChartCPF = [], labelsChartCPF = [];
    let datasetsChartRating = [], labelsChartRating = [];
    let datasetsChartBoost = [], labelsChartBoost = [], BoostEXP = [], BoostMercato = [], BoostOpportunita = [], BoostSegnalazione = []
    //aggiungo i dati dei selezionati
    this.state.clientsData.map((client) => {
      datasetsChartCCB.push(
        {
          label: client.name,
          fill: false,
          lineTension: 0.1,
          borderWidth: 1,
          borderColor: 'rgba(' + client.color + ',1)',
          pointRadius: 3,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBorderColor: 'rgba(' + client.color + ',1)',
          pointBackgroundColor: 'rgba(' + client.color + ',1)',
          data: [client.chartCCBData][0]
        })
      labelsChartCCB = client.chartCCBLabels

      datasetsChartCCM.push(
        {
          label: client.name,
          fill: false,
          lineTension: 0.1,
          borderWidth: 1,
          borderColor: 'rgba(' + client.color + ',1)',
          pointRadius: 3,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBorderColor: 'rgba(' + client.color + ',1)',
          pointBackgroundColor: 'rgba(' + client.color + ',1)',
          data: [client.chartCCMData][0]
        })
      labelsChartCCM = client.chartCCMLabels

      datasetsChartCPF.push(
        {
          label: client.name,
          fill: false,
          lineTension: 0.1,
          borderWidth: 1,
          borderColor: 'rgba(' + client.color + ',1)',
          pointRadius: 3,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBorderColor: 'rgba(' + client.color + ',1)',
          pointBackgroundColor: 'rgba(' + client.color + ',1)',
          data: [client.chartCPFData][0]
        })
      labelsChartCPF = client.chartCPFLabels

      datasetsChartRating.push(
        {
          label: client.name,
          fill: false,
          lineTension: 0.1,
          borderWidth: 1,
          borderColor: 'rgba(' + client.color + ',1)',
          pointRadius: 3,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBorderColor: 'rgba(' + client.color + ',1)',
          pointBackgroundColor: 'rgba(' + client.color + ',1)',
          data: [client.chartRatingData][0]
        })
      labelsChartRating = client.chartRatingLabels

      if (client.chartBoostData.length > 0) {
        BoostEXP.push(client.chartBoostData[0])
        BoostMercato.push(client.chartBoostData[1])
        BoostOpportunita.push(client.chartBoostData[2])
        BoostSegnalazione.push(client.chartBoostData[3])
        labelsChartBoost.push(client.name.length > 10 ? (client.name.substring(0, 7) + "...") : client.name)
      }

    })

    //aggiungo metriche per Boost
    datasetsChartBoost.push(
      {
        label: "EXP",
        backgroundColor: 'rgba(227,38,54, 0.8)',
        data: BoostEXP
      })
    datasetsChartBoost.push(
      {
        label: "Mercato",
        backgroundColor: 'rgba(0,181,199, 0.8)',
        data: BoostMercato
      })
    datasetsChartBoost.push(
      {
        label: "Opportunita",
        backgroundColor: 'rgba(31,117,254, 0.8)',
        data: BoostOpportunita
      })
    datasetsChartBoost.push(
      {
        label: "Segnalazione",
        backgroundColor: 'rgba(169,169,169, 0.8)',
        data: BoostSegnalazione
      })

    let { bestClients } = this.state
    //aggiungo i migliori
    datasetsChartCCB.push(
      {
        label: bestClients[0].name,
        fill: false,
        lineTension: 0.1,
        borderWidth: 1,
        borderColor: 'rgba(' + bestClients[0].color + ',1)',
        pointRadius: 3,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointHoverBorderColor: 'rgba(' + bestClients[0].color + ',1)',
        pointBackgroundColor: 'rgba(' + bestClients[0].color + ',1)',
        data: [bestClients[0].chartCCBData][0]
      })

    datasetsChartCCM.push(
      {
        label: bestClients[1].name,
        fill: false,
        lineTension: 0.1,
        borderWidth: 1,
        borderColor: 'rgba(' + bestClients[1].color + ',1)',
        pointRadius: 3,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointHoverBorderColor: 'rgba(' + bestClients[1].color + ',1)',
        pointBackgroundColor: 'rgba(' + bestClients[1].color + ',1)',
        data: [bestClients[1].chartCCMData][0]
      })

    datasetsChartCPF.push(
      {
        label: bestClients[2].name,
        fill: false,
        lineTension: 0.1,
        borderWidth: 1,
        borderColor: 'rgba(' + bestClients[2].color + ',1)',
        pointRadius: 3,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointHoverBorderColor: 'rgba(' + bestClients[2].color + ',1)',
        pointBackgroundColor: 'rgba(' + bestClients[2].color + ',1)',
        data: [bestClients[2].chartCPFData][0]
      })

    datasetsChartRating.push(
      {
        label: bestClients[3].name,
        fill: false,
        lineTension: 0.1,
        borderWidth: 1,
        borderColor: 'rgba(' + bestClients[3].color + ',1)',
        pointRadius: 3,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointHoverBorderColor: 'rgba(' + bestClients[3].color + ',1)',
        pointBackgroundColor: 'rgba(' + bestClients[3].color + ',1)',
        data: [bestClients[3].chartRatingData][0]
      })

    let { chartCCBData, chartCCMData, chartCPFData, chartRatingData, chartCPFOptions, chartBoostData } = this.state
    chartCCBData.datasets = datasetsChartCCB
    chartCCBData.labels = labelsChartCCB
    chartCCMData.datasets = datasetsChartCCM
    chartCCMData.labels = labelsChartCCM
    chartCPFData.datasets = datasetsChartCPF
    chartCPFData.labels = labelsChartCPF
    chartRatingData.datasets = datasetsChartRating
    chartRatingData.labels = labelsChartRating
    chartBoostData.datasets = datasetsChartBoost
    chartBoostData.labels = labelsChartBoost
    chartCPFOptions.scales.yAxes[0].ticks.min = this.state.clientsData[0].chartCPFMin - 2
    chartCPFOptions.scales.yAxes[0].ticks.max = this.state.clientsData[0].chartCPFMax + 2
    this.setState({
      chartCCBData,
      chartCCMData,
      chartCPFData,
      chartRatingData,
      chartBoostData,
      showChart: true,
      chartCPFOptions
    })
  }

  toggleChart(cleanedData) {
    window.scrollTo(0, 0);
    if (this.state.showChart) {
      this.setState({
        showChart: false,
      })
    } else {
      this.setState({
        clientsData: cleanedData,
        clientsForLegend: cleanedData
      })
      this.loadChartsData()
    }
  }

  toggleChartDetails(chartName) {
    window.scrollTo(0, 0);
    let { showChartDetails } = this.state
    if (showChartDetails) {
      this.setState({
        showChartDetails: false
      })
    }
    switch (chartName) {
      case 'ccb':
        let { chartCCBData, chartCCBOptions } = this.state
        chartCCBOptions.indexName = "ccb"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'CCF',
          chartDetailsDescription: 'Evoluzione Coefficiente di Crescita Finanziario negli anni',
          chartDetailsChartData: chartCCBData,
          chartDetailsChartOptions: chartCCBOptions,
        })
        break;
      case 'ccm':
        let { chartCCMData, chartCCMOptions } = this.state
        chartCCMOptions.indexName = "ccm"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'CCM',
          chartDetailsDescription: 'Evoluzione Coefficiente di Crescita di Mercato negli anni',
          chartDetailsChartData: chartCCMData,
          chartDetailsChartOptions: chartCCMOptions,
        })
        break;
      case 'cpf':
        let { chartCPFData, chartCPFOptions } = this.state
        chartCPFOptions.indexName = "cpf"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'CPF',
          chartDetailsDescription: 'Evoluzione Coefficiente di Potenza di Fuoco negli anni',
          chartDetailsChartData: chartCPFData,
          chartDetailsChartOptions: chartCPFOptions,
        })
        break;
      case 'rating':
        let { chartRatingData, chartRatingOptions } = this.state
        chartRatingOptions.indexName = "punteggio_my_client"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Rating',
          chartDetailsDescription: 'Evoluzione Rating negli anni',
          chartDetailsChartData: chartRatingData,
          chartDetailsChartOptions: chartRatingOptions,
        })
        break;

      default:
        break;
    }
  }

  renderCharts() {
    // let { bestClients, clientsForLegend } = this.state
    // let toBeAdded
    // bestClients.map(async (bestClient) => {
    //   toBeAdded = true
    //   toBeAdded = await clientsForLegend.map(client => {
    //     if (client.id == bestClient.id) {
    //       return -1
    //     }
    //   })
    //   if (toBeAdded) {
    //     //QCLIENT: it doesnt work
    //     await clientsForLegend.push(bestClient)
    //   }
    // })


    return (
      <>
        <Legend clientsData={this.state.clientsData} vertical={false} />
        <Row>
          <Col md="6">
            <Card>
              <CardBody>
                <Row>
                  <Col md="8" className="mb-3">
                    <h3 className="text-left mb-0">CPF</h3>
                    <p className="text-left">Coefficiente potenza di Fuoco</p>
                  </Col>
                  <Col md="4">
                    <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('cpf')}>Dettaglio</Button>
                  </Col>
                </Row>
                <Line data={this.state.chartCPFData} height={150} width={null} options={this.state.chartCPFOptions} />
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <Card>
              <CardBody>
                <Row>
                  <Col md="8" className="mb-3">
                    <h3 className="text-left mb-0">CCM</h3>
                    <p className="text-left">Coefficiente di crescita di Mercato</p>
                  </Col>
                  <Col md="4">
                    <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('ccm')}>Dettaglio</Button>
                  </Col>
                </Row>
                <Line data={this.state.chartCCMData} height={150} width={null} options={this.state.chartCCMOptions} />
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <Card>
              <CardBody>
                <Row>
                  <Col md="8" className="mb-3">
                    <h3 className="text-left mb-0">CCF</h3>
                    <p className="text-left">Coefficiente di crescita Finanziaria</p>
                  </Col>
                  <Col md="4">
                    <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('ccb')}>Dettaglio</Button>
                  </Col>
                </Row>
                <Line data={this.state.chartCCBData} height={150} width={null} options={this.state.chartCCBOptions} />
              </CardBody>
            </Card>
          </Col>
          {this.props.user.settoriale == 1 ? (<Col md="6" >
            <Card>
              <CardBody>
                <Row>
                  <Col md="8" className="mb-3">
                    <h3 className="text-left mb-0">Rating</h3>
                    <p className="text-left">Livello di rischio del competitor</p>
                  </Col>
                  <Col md="4">
                    <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('rating')}>Dettaglio</Button>
                  </Col>
                </Row>
                <Line data={this.state.chartRatingData} height={150} width={null} options={this.state.chartRatingOptions} />
              </CardBody>
            </Card>
          </Col>) : (<Col md="6" >
            <Card>
              <CardBody>
                <Row>
                  <Col md="8" className="mb-3">
                    <h3 className="text-left mb-0">Boost</h3>
                    <p className="text-left">Coefficiente di Propulsione</p>
                  </Col>
                </Row>
                <Row>
                  <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(169,169,169, 0.8)" }}></p><p className="client-legend-name">Segnalazione</p></div>
                  <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(31,117,254, 0.8)" }}></p><p className="client-legend-name">Opportunita</p></div>
                  <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(0,181,199, 0.8)" }}></p><p className="client-legend-name">Mercato</p></div>
                  <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(227,38,54, 0.8)" }}></p><p className="client-legend-name">EXP</p></div>
                </Row>
                <Bar data={this.state.chartBoostData} height={150} width={null} options={this.state.chartBoostOptions} />
              </CardBody>
            </Card>
          </Col>)}
        </Row>
        <Row>
          <Col md="12">
            <div className="clearfix mt-5">
              <Button className="animation-on-hover float-right text-center ml-3" color="secondary" onClick={this.toggleChart}>Torna indietro</Button>
            </div>
          </Col>
        </Row>
      </>
    )
  }

  render() {

    if (this.state.showChart === false) {
      return (
        <div className="content">
          <ClientsList
            //QCLIENT: migliorare con minCheckboxes
            {...this.props}
            maxCheckboxes={this.props.user.settoriale == 0 ? 5 : 10}
            onDataDownloaded={this.toggleChart}
            btnTitle={"Crea grafici"}
            type={"coefficienti-e-indici"}
          />
        </div>
      )
    } else {
      if (this.state.showChartDetails !== false) {
        return (
          <div className="content">
            <ChartDetails
              user={this.props.user}
              title={this.state.chartDetailsTitle}
              description={this.state.chartDetailsDescription}
              chartData={this.state.chartDetailsChartData}
              chartOptions={this.state.chartDetailsChartOptions}
              toggleChartDetails={this.toggleChartDetails}
              clientsData={this.state.clientsData}
            />
          </div>
        )
      } else {
        return (
          <div className="content">
            {this.renderCharts()}
          </div>
        )
      }
    }
  }
}

CoefficientiEIndici.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(CoefficientiEIndici);